export const LOGIN = 'LOGIN';
export const CHECK_AUTH = 'CHECK_AUTH';
export const LOGOUT = 'LOGOUT';